/**
 * This file contains reducers for common cases.
 * Use them and avoid of code duplication.
 * For examples check out meeting-notes redux stuff
 */

import * as R from 'ramda';

import { listToItems } from '../../utils';

export const defaultState = {
  items: {},
  isFetching: false,
  isCreating: false,
  isUpdating: false,
  isRemoving: false,
};

export const operationTypes = {
  fetch: 'isFetching',
  create: 'isCreating',
  update: 'isUpdating',
  remove: 'isRemoving',
};

export const commonRequestReducer = field => R.mergeDeepLeft({ [field]: true });
export const commonFailureReducer = field => R.mergeDeepLeft({ [field]: false });

export const commonSetPageReducer = (state, { payload }) => ({
  ...state,
  page: payload,
  [operationTypes.fetch]: false,
});

export const createSuccessReducer = (state, { payload }) => ({
  ...state,
  [operationTypes.create]: false,
  items: {
    ...state.items,
    ...R.equals(R.type(payload), 'Array')
      ? listToItems(payload)
      : { [payload._id]: payload },
  },
});

export const updateSuccessReducer = (state, { payload }) => ({
  ...state,
  [operationTypes.update]: false,
  items: {
    ...state.items,
    [payload._id]: payload,
  },
});

export const deleteSuccessReducer = (state, { payload = {} }) => ({
  ...state,
  [operationTypes.remove]: false,
  items: R.dissoc(payload._id, state.items),
});

export const fetchSuccessReducer = (state, { payload = {} }) => ({
  ...state,
  [operationTypes.fetch]: false,
  items: {
    ...state.items,
    ...R.equals(R.type(payload), 'Array')
      ? listToItems(payload)
      : payload,
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/common.js